import SelectDeliveryMethod from './SelectDeliveryMethod';

export default SelectDeliveryMethod;
